/**
 * Created by Vladislav on 02.04.2025.
 */

const RoomRepairView = cc.Node.extend({
    ctor: function (room) {
        this._super();

        this.room = room;

        const styles = cleverapps.styles.RoomRepairView;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles);
        this.setLocalZOrder(10);

        this.stageNo = this.room.calcCurrentItem();

        this.createText();
        this.createIcon();
        if (!this.isComingSoon()) {
            this.createRewards();
        }

        cleverapps.UI.wrap(this);

        this.setCascadeOpacityEnabledRecursively(true);

        this.clickListener = cleverapps.UI.onClick(this, () => this.onClick());
        this.hoverListener = cleverapps.UI.applyHover(this);

        room.on("changeStars", this.updateState.bind(this), this);

        this.updateState();

        this.onResize();
    },

    onResize: function () {
        this.setScale(cleverapps.resolution.isVertical() ? 0.7 : 1);
        this.baseScale = this.scale;
    },

    getStageNo: function () {
        return this.stageNo;
    },

    isComingSoon: function () {
        return this.room.location.isLocationCompleted();
    },

    createIcon: function () {
        const styles = cleverapps.styles.RoomRepairView;

        const location = this.room.location;

        const iconBg = this.iconBg = new cc.Sprite(this.isReady() ? bundles.merge.frames.repair_icon_bg_ready : bundles.merge.frames.repair_icon_bg);
        iconBg.setAlignment(styles.iconBg);
        this.addChild(iconBg);

        const icon = this.icon = new cc.Sprite(bundles[location.getRoomBundleId(location.getCurrentRoom())].frames[`icon_item_${this.isComingSoon() ? "soon" : this.stageNo}`]);
        icon.setAlignment(iconBg.width / 2, iconBg.height / 2);
        iconBg.addChild(icon);

        cleverapps.UI.fitToBox(icon, {
            width: iconBg.width * 0.55,
            height: iconBg.height * 0.55
        });
    },

    isReady: function () {
        return this.room.location.stars.isEnoughStars();
    },

    getText: function () {
        return this.isComingSoon() ? Messages.get("Soon") : `${this.room.location.calcStarsForStage()}%%`;
    },

    createText: function () {
        const styles = cleverapps.styles.RoomRepairView;

        const textBg = this.textBg = cleverapps.UI.createScale9Sprite(bundles.merge.frames.repair_text_bg, {
            x: 0.4,
            y: 0.5
        });
        textBg.setContentSize(styles.textBg);
        textBg.setAnchorPoint(0, 0.5);
        textBg.setAlignment(styles.textBg);
        this.addChild(textBg);

        const text = this.getText();

        const textWithIcon = this.textWithIcon = new TextWithIcon(text, {
            font: cleverapps.styles.FONTS.ROOM_REPAIR_TEXT,
            icons: {
                "%%": bundles.reward_icons.frames.order_completion_star_png
            },
            margin: cleverapps.styles.RoomRepairView.text.margin
        });
        cleverapps.UI.fitToBox(textWithIcon, {
            width: styles.text.width,
            height: styles.text.height
        });
        textWithIcon.setAlignment(styles.text);
        textBg.addChild(textWithIcon);
    },

    createRewards: function () {
        if (this.rewards) {
            this.rewardsList = undefined;

            this.rewards.removeFromParent();
            this.rewards = undefined;

            this.lowerRewards.removeFromParent();
            this.lowerRewards = undefined;
        }

        const reward = this.room.getRewardsForFix();
        if (!reward) {
            return;
        }

        const styles = cleverapps.styles.RoomRepairView.rewards;

        const rewardsList = this.rewardsList = new RewardsListComponent(reward, {
            font: cleverapps.styles.FONTS.ROOM_REPAIR_REWARDS_TEXT,
            columns: reward.listRewards().length,
            textDirection: cleverapps.UI.HORIZONTAL,
            hideTextForSingleReward: true,
            noPrefix: true,
            iconWrap: { height: styles.iconWrap.height },
            margin: styles.margin,
            textMargin: styles.textMargin,
            noShowControls: true
        });

        const bg = this.rewards = new cc.Scale9Sprite(bundles.merge.frames.rewards_substrate_png);
        bg.setContentSize2(rewardsList.width + styles.offset, bg.height);
        bg.setAlignment(reward.listRewards().length > 3 ? styles.multiple : styles);
        this.addChild(bg, 10);

        const leftCorner = new cc.Sprite(bundles.merge.frames.rewards_substrate_left_png);
        leftCorner.setAlignment(styles.leftCorner);
        bg.addChild(leftCorner);

        const rightCorner = new cc.Sprite(bundles.merge.frames.rewards_substrate_right_png);
        rightCorner.setAlignment(styles.rightCorner);
        bg.addChild(rightCorner);

        rewardsList.setAlignment(styles.rewards);
        bg.addChild(rewardsList);

        const container = this.lowerRewards = new cc.Node();
        this.addChild(container, -1);
        leftCorner.replaceParentSamePlace(container);
        rightCorner.replaceParentSamePlace(container);

        bg.setCascadeOpacityEnabledRecursively(true);
        container.setCascadeOpacityEnabledRecursively(true);
    },

    updateState: function () {
        const location = this.room.location;

        if (this.rays) {
            this.rays.removeFromParent();
            this.rays = undefined;
        }

        if (!this.isReady() || location.isLocationCompleted()) {
            this.iconBg.setSpriteFrame(bundles.merge.frames.repair_icon_bg);
        } else {
            this.iconBg.setSpriteFrame(bundles.merge.frames.repair_icon_bg_ready);

            this.rays = StandartAnimations.rays(this);
            this.rays.setAlignment(this.iconBg.x, this.iconBg.y);
            this.rays.setLocalZOrder(-2);

            this.stopAllActions();
            this.runAction(new cc.RepeatForever(new cc.Sequence(
                new cc.DelayTime(6),
                new cc.CallFunc(() => {
                    const rate = 0.8;

                    [this.iconBg, this.textWithIcon].forEach((item) => {
                        item.stopAllActions();

                        const baseScale = item.getScale() || 1;

                        item.runAction(new cc.Sequence(
                            new cc.ScaleTo(0.18, 0.9 * baseScale).easing(cc.easeOut(rate)),
                            new cc.ScaleTo(0.25, 1.05 * baseScale).easing(cc.easeOut(rate)),
                            new cc.ScaleTo(0.25, 0.95 * baseScale).easing(cc.easeOut(rate)),
                            new cc.ScaleTo(0.25, baseScale).easing(cc.easeOut(rate))
                        ));
                    });
                })
            )));
        }
    },

    onAfterNextStage: function (callback) {
        new ActionPlayer([
            (f) => {
                this.hoverListener.setEnabled(false);
                this.clickListener.setEnabled(false);
                this.inAnimation = true;

                this.stopAllActions();

                cleverapps.effects.fire("location.garden.room.item.open");

                this.iconBg.setScale(0.5);
                this.iconBg.setOpacity(0);
                this.iconBg.runAction(new cc.Spawn(
                    new cc.FadeIn(0.2),
                    new cc.ScaleTo(0.4, 1).easing(cc.easeBackOut(5))
                ));

                this.textBg.setOpacity(0);
                this.textBg.runAction(new cc.Sequence(
                    new cc.DelayTime(0.1),
                    new cc.FadeTo(0, 50),
                    new cc.FadeTo(0.2, 255)
                ));

                if (this.rays) {
                    this.rays.removeFromParent();
                    this.rays = undefined;
                }

                cleverapps.timeouts.setTimeout(f, 500);
            },

            (f) => {
                this.hoverListener.setEnabled(true);
                this.clickListener.setEnabled(true);
                this.inAnimation = false;

                this.updateState();

                f();
            }
        ]).play(callback);
    },

    onClick: function () {
        cleverapps.effects.fire("ui.button.click");

        const location = this.room.location;

        location.displayNewTaskWindow();
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ROOM_REPAIR_TEXT: {
        size: 55,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    ROOM_REPAIR_REWARDS_TEXT: {
        size: 36,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.RoomRepairView = {
    width: 300,
    height: 140,

    iconBg: {
        x: { align: "left" },
        y: { align: "center" }
    },

    textBg: {
        width: 190,
        height: 77,

        idleAnimation: {
            width: 7
        },

        showAnimation: {
            width: 100
        },

        hideAnimation: {
            dx: -50
        },

        x: { align: "right" },
        y: { align: "center" }
    },

    text: {
        width: 120,
        height: 55,

        margin: 10,

        x: { align: "center" },
        y: { align: "center" },

        clickAnimation: {
            dx: -20,
            dx2: 10
        },

        hoverAnimation: {
            dx: 7
        }
    },

    rewards: {
        x: { align: "center", dx: -82 },
        y: { align: "bottom", dy: -45 },

        multiple: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -45 }
        },

        iconWrap: {
            width: 50,
            height: 50
        },
        rewards: {
            x: { align: "center" },
            y: { align: "center" }
        },
        leftCorner: {
            x: { align: "left", dx: -38 },
            y: { align: "bottom", dy: 30 }
        },
        rightCorner: {
            x: { align: "right", dx: 38 },
            y: { align: "bottom", dy: 30 }
        },
        offset: 85,
        margin: { x: 10, y: 0 },
        textMargin: 0
    }
};